<template>
  <div id="app">
    <PaginaNaoEncontrada v-if="contratoValido===false"/>
    <router-view v-if="contratoValido"/>
  </div>
</template>

<script>
  import contratoService from './services/contrato/contratoService';
  import PaginaNaoEncontrada from './modules/erro/pagina-nao-encontrada/pagina-nao-encontrada'

  export default {
    name: 'App',
    components: {
      PaginaNaoEncontrada
    },
    data() {
      return {
        contratoValido: null
      };
    },
    mounted() {
      this.checkContractValidity();
    },
    methods: {
      checkContractValidity() {
        contratoService.getContratoValido().then(response => {
          this.contratoValido = response.data;
        }).catch(error => {
          console.error('Error:', error);
          
        });
      }
    }
  }
</script>

<style lang="less">
  body {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    color: #1f394d;
  }

  a {
    color: #4a8be9;
  }

</style>
